import { render } from "./BlogContent.vue?vue&type=template&id=1aad1546&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__